import React from 'react';
import { CONSTANTES } from '../../config/constantaes';

const ProximoSorteoBanner = ({ fecha = CONSTANTES.FECHA_CAMPANIA }) => (
  <div className="custom-div">
      ¡Últimos días para participar!
    <span role="img" aria-label="gift">&#127873;</span>
    <span style={{ marginLeft: '8px' }}>
      Pr&oacute;ximo sorteo: <strong>{fecha}</strong>
    </span>
  </div>
);

export default ProximoSorteoBanner;
